import { BrowserRouter, Routes, Route, Link, Outlet } from 'react-router-dom';
import { OrderProvider } from './context/OrderContext';
import { DesignProvider } from './context/DesignContext';
import { HomePage } from './pages/HomePage';
import { DesignPage } from './pages/DesignPage';
import { EditorPage } from './pages/EditorPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { OrderStatusPage } from './pages/OrderStatusPage';
import { AdminTemplatesPage } from './pages/AdminTemplatesPage';
import { StepIndicator } from './components/StepIndicator';
import { FloatingBar } from './components/FloatingBar';

function Layout() {
  return (
    <>
      <header className="sticky-header">
        <div className="header-inner">
          <Link to="/" className="logo">
            flashcard<span className="logo-dot">.</span>
          </Link>
          <nav className="header-nav">
            <Link to="/design">Design</Link>
            <Link to="/checkout">Kasse</Link>
            <Link to="/admin/templates">Admin</Link>
          </nav>
        </div>
        <StepIndicator />
      </header>

      <div className="container">
        <Outlet />
      </div>

      <FloatingBar />
    </>
  );
}

export function App() {
  return (
    <OrderProvider>
      <DesignProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="design" element={<DesignPage />} />
              <Route path="editor" element={<EditorPage />} />
              <Route path="checkout" element={<CheckoutPage />} />
              <Route path="order/:id" element={<OrderStatusPage />} />
              <Route path="admin/templates" element={<AdminTemplatesPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </DesignProvider>
    </OrderProvider>
  );
}
